import React from 'react';
import { FaBoreHole } from 'react-icons/fa6';
import { NavSubmenuDivider, NavSubmenuLabel } from './navMenuLayout';
import AreaBudgetNavPanel from './AreaBudgetNavPanel';
import { canAccessAreaBudgetMenu } from './areaBudgetNavUtils';

const DRILLING_CHILD_ROUTES = [
  '/drilling/dashboard',
  '/budgets/drilling',
  '/budgets/drilling/new',
  '/budgets/management?area=drilling',
  '/dailies/drilling/new',
  '/dailies/management?area=drilling',
  '/summary/drilling',
  '/drilling/sp-registry',
  '/drilling/crew-reports',
  '/drilling/crew-report-field',
  '/drilling/npt-log',
  '/drilling/progress-map',
  '/drilling/work-planning',
  '/drilling/work-projection',
  '/drilling/client-daily-report',
  '/drilling/cdr-archive',
  '/drilling/npt-report-archive',
];

export default function DrillingNavSection({
  MenuItem,
  SubMenuItem,
  hasMenuAccess,
  hasMenuAccessOrChild,
  approvedPresence,
  closeMobileSidebar,
}) {
  if (!hasMenuAccessOrChild('/drilling', DRILLING_CHILD_ROUTES)) {
    return null;
  }

  const canAccessBudget = canAccessAreaBudgetMenu('drilling', hasMenuAccess);

  return (
    <MenuItem customIcon={<FaBoreHole style={{ width: '24px', height: '24px' }} />} title="Drilling" id="drilling">
      {approvedPresence?.drilling && hasMenuAccess('/drilling/dashboard') && (
        <SubMenuItem to="/drilling/dashboard">Dashboard</SubMenuItem>
      )}
      {(canAccessBudget
        || (approvedPresence?.drilling && (hasMenuAccess('/dailies/drilling/new') || hasMenuAccess('/dailies/management?area=drilling')))) && (
        <>
          <NavSubmenuLabel>Planning</NavSubmenuLabel>
          {canAccessBudget && (
            <AreaBudgetNavPanel
              area="drilling"
              SubMenuItem={SubMenuItem}
              hasMenuAccess={hasMenuAccess}
              closeMobileSidebar={closeMobileSidebar}
            />
          )}
          {hasMenuAccess('/dailies/drilling/new') && <SubMenuItem to="/dailies/drilling/new">New Daily</SubMenuItem>}
          {hasMenuAccess('/dailies/management?area=drilling') && (
            <SubMenuItem to="/dailies/management?area=drilling">Dailies Management</SubMenuItem>
          )}
        </>
      )}
      {(hasMenuAccess('/drilling/sp-registry')
        || hasMenuAccess('/drilling/crew-reports')
        || hasMenuAccess('/drilling/crew-report-field')
        || hasMenuAccess('/drilling/npt-log')
        || hasMenuAccess('/drilling/progress-map')
        || hasMenuAccess('/drilling/work-planning')
        || hasMenuAccess('/drilling/work-projection')) && (
        <>
          <NavSubmenuDivider />
          <NavSubmenuLabel>Operations</NavSubmenuLabel>
          {hasMenuAccess('/drilling/sp-registry') && <SubMenuItem to="/drilling/sp-registry">SP Registry</SubMenuItem>}
          {hasMenuAccess('/drilling/crew-reports') && <SubMenuItem to="/drilling/crew-reports">Crew Reports</SubMenuItem>}
          {hasMenuAccess('/drilling/crew-report-field') && (
            <SubMenuItem to="/drilling/crew-report-field">+ New Crew Report</SubMenuItem>
          )}
          {hasMenuAccess('/drilling/npt-log') && <SubMenuItem to="/drilling/npt-log">NPT Log</SubMenuItem>}
          {hasMenuAccess('/drilling/progress-map') && (
            <SubMenuItem to="/drilling/progress-map">📍 Drill Progress Map</SubMenuItem>
          )}
          {hasMenuAccess('/drilling/work-planning') && (
            <SubMenuItem to="/drilling/work-planning">Drill Work Planning</SubMenuItem>
          )}
          {hasMenuAccess('/drilling/work-projection') && (
            <SubMenuItem to="/drilling/work-projection">📈 Work Projection</SubMenuItem>
          )}
        </>
      )}
      {(hasMenuAccess('/summary/drilling')
        || hasMenuAccess('/drilling/client-daily-report')
        || hasMenuAccess('/drilling/cdr-archive')
        || hasMenuAccess('/drilling/npt-report-archive')) && (
        <>
          <NavSubmenuDivider />
          <NavSubmenuLabel>Reports</NavSubmenuLabel>
          {approvedPresence?.drilling && hasMenuAccess('/summary/drilling') && (
            <SubMenuItem to="/summary/drilling">Summary</SubMenuItem>
          )}
          {hasMenuAccess('/drilling/client-daily-report') && (
            <SubMenuItem to="/drilling/client-daily-report">Client Daily Report</SubMenuItem>
          )}
          {hasMenuAccess('/drilling/cdr-archive') && <SubMenuItem to="/drilling/cdr-archive">CDR Archive</SubMenuItem>}
          {hasMenuAccess('/drilling/npt-report-archive') && (
            <SubMenuItem to="/drilling/npt-report-archive">NPT Report Archive</SubMenuItem>
          )}
        </>
      )}
    </MenuItem>
  );
}
